import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, Observable } from 'rxjs';
import { Customer, UserCredentials } from '@models/customer.model';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private readonly http = inject(HttpClient);
  private readonly ENDPOINT = 'users';

  getAll(): Observable<Customer[]> {
    return this.http.get<Customer[]>(`${environment.apiBaseUrl}/${this.ENDPOINT}`);
  }

  update(customer: Partial<Customer> & { id: string }): Observable<Customer> {
    const { addresses, idp, ...rest } = customer;
    const payload = {
      customer: rest,
      addresses
    };
    return this.http.patch<{ customer: Customer }>(`${environment.apiBaseUrl}/${this.ENDPOINT}/${customer.id}`, payload).pipe(
      map(res => res.customer)
    );
  }

  create(user: Customer): Observable<Customer> {
    const { addresses, idp, ...rest } = user;
    const payload = {
      customer: rest,
      addresses,
      idp
    };
    return this.http.post<{ customer: Customer }>(`${environment.apiBaseUrl}/${this.ENDPOINT}`, payload).pipe(
      map(res => res.customer)
    );
  }

  delete(id: string): Observable<string> {
    return this.http.delete<string>(`${environment.apiBaseUrl}/${this.ENDPOINT}/${id}`);
  }

  updatePassword(userCredentials: UserCredentials): Observable<void> {
    return this.http.patch<void>(`${environment.apiBaseUrl}/${this.ENDPOINT}/credentials/${userCredentials.id}`, userCredentials);
  }

  getProfile(): Observable<Customer> {
    return this.http.get<Customer>(`${environment.apiBaseUrl}/profile`);
  }

  updateProfile(customer: Partial<Customer>): Observable<Customer> {
    const { addresses, idp, ...rest } = customer;
    const payload = {
      customer: rest,
      addresses
    };
    return this.http.patch<{ customer: Customer }>(`${environment.apiBaseUrl}/profile`, payload).pipe(
      map(res => res.customer)
    );
  }
}
